
Monet.Grid = Monet.Grid || {};
Monet.Grid.ActionsModules = Monet.Grid.ActionsModules || {};

Monet.Grid.ActionsModules.AutoRefresh = function () {
  this.entity = null;
  this.selector = null;
  this.id = 'autoRefreshCheckBox';
  this.screenName = null;

  this.setScreenName = function (screenName) {
    this.screenName = screenName;
  };

  this.setEntity = function (entity) {
    this.entity = entity;
  };

  this.setSelector = function (selector) {
    this.selector = selector;
  };

  this.setIntervalToUpdate = function () {
    this.intervalId = setInterval(() => {
      if (GreenmileTabPanel.getActiveTab() === this.screenName) {
        const resetCollection = false;
        const action = 'update';
        const router = App.Objects[this.entity];
        const updater = App.Forms[this.entity].controlUpdater;
        router.updateGrid(router.getFilter(), updater.updateDataToGrid, resetCollection, action);
      }
    }, 300000);
  };

  this.clearIntervalToUpdate = function () {
    if(this.intervalId) {
      clearInterval(this.intervalId);
    }
  };

  this.renderRefreshGridCheckbox = function () {
    const container = document.createElement('div');
    const checkbox = document.createElement('input');
    const label = document.createElement('label');
    const storage = new Greenmile.Storage.StoreMapPosition();
    const autoRefreshStatus = JSON.parse(storage.getAutoRefreshStatus());

    checkbox.type = 'checkbox';
    checkbox.id = this.id;
    checkbox.onchange = (event) => {
      if (event.target.checked) {
        this.setIntervalToUpdate();
        storage.setAutoRefreshStatus(true);
      } else {
        this.clearIntervalToUpdate();
        storage.setAutoRefreshStatus(false);
      }
    };

    if(autoRefreshStatus == true) {
      checkbox.checked = true;
      this.setIntervalToUpdate();
    } else {
      checkbox.checked = false;
      this.clearIntervalToUpdate();
    }

    label.setAttribute('for', this.id);
    label.innerHTML = Monet.I18n.getResourcesByKey('autoRefresh');

    container.className = 'autoRefresh gridActionDiv';
    container.appendChild(label);
    container.appendChild(checkbox);

    return container;
  };

  this.init = function () {
    const containner = document.querySelector(`${this.selector} .MonetUIGridActions`);
    containner.appendChild(this.renderRefreshGridCheckbox());
  };
};
